import colors from './colors';
import fonts from './fonts';
import layouts from './layouts';
import mediaQueries from './mediaQueries';
import breakpoints from './mediaQueries';
import mixins from './mixins';
import zIndices from './zIndices';

const theme = {
  colors,
  fonts,
  layouts,
  mediaQueries,
  breakpoints,
  mixins,
  zIndices,
};

export default theme;
